<app-search-ui></app-search-ui>
<nb-card class="dashInfoCard">
  <nb-card-header>
    <h3>eGlu Today</h3>
  </nb-card-header>
  <nb-card-body>
    <div class="summary-container">
      <div *ngFor="let item of summary">
        <div>{{ item.title }}</div>
        <div class="h6">{{ item.value }}</div>
      </div>
    </div>
    <!-- <div class="showGlobalEngagementSection">
      <nb-toggle labelPosition="start" [(ngModel)]="showGlobalEngagement">Show global engagement data
      </nb-toggle>
    </div> -->
    <div class="summary-container" *ngIf="showGlobalEngagement"
      style="padding:0px;">
      <nb-card style="width: 100%;">
        <nb-card-header>
          <nb-select [(selected)]="selectedComparePeriod"
            (selectedChange)="_comparePeriodChanged()">
            <nb-select-label>
              {{ engagementPeriods[selectedComparePeriod] }}
            </nb-select-label>
            <nb-option value="0">Daily</nb-option>
            <nb-option value="1">Weekly</nb-option>
            <nb-option value="2">Fortnightly</nb-option>
            <nb-option value="3">Monthly</nb-option>
            <nb-option value="4">Quarterly</nb-option>
            <nb-option value="5">Yearly</nb-option>
          </nb-select>
        </nb-card-header>
        <nb-card-body>

          <plotly-plot [config]="grapgConfig" [data]="engagementGraph.data"
            [layout]="engagementGraph.layout"></plotly-plot>

        </nb-card-body>
      </nb-card>
    </div>
  </nb-card-body>
</nb-card>

<!-- eGlu summary card -->
<nb-card style="border-radius: 18px;">
  <div class="SummaryInfoCard">
    <nb-card-body>
      <div style="margin-bottom: 2%; margin-left: 8px;">
        <div><h3>eGlu Summary</h3></div>
      </div>
      <mat-tab-group (selectedTabChange)="onTabChanged($event)">
        <mat-tab label="Installations">
          <div class="summary-card-body">
            <div class="radio-div">
              <nb-radio-group name="radio-grp-installs"
                [(value)]="selectedRadioOptionInstalls" class="radio-btn-group">
                <nb-radio [value]="1">HUBS</nb-radio>
                <nb-radio [value]="2">Nodes</nb-radio>
              </nb-radio-group>
            </div>
            <div class="select-menu">
              <div class="select-options">
                <div><b style="font-size: 15px;">Select period of days </b>
                  <nb-select size="small" [(selected)]="selectedDaysPeriod"
                    (selectedChange)="setDaysPeriod()">
                    <nb-select-label>
                      <!-- If custom date range is selected, then show the date range as label else the current selected predefined day range-->
                      {{this.dateRange['startDate']!==""?this.dateRange['startDate']+'-'+this.dateRange['endDate']:
                      engagementDays[selectedDaysPeriod] }}
                    </nb-select-label>
                    <nb-option value="0">Last 7 days</nb-option>
                    <nb-option value="1">Last 15 days</nb-option>
                    <nb-option value="2">Last 30 days</nb-option>
                    <nb-option value="3">Custom Date Range</nb-option>
                  </nb-select>
                </div>
              </div>
            </div>
            <div class="loader" *ngIf="loading">
              <div>
                <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
              </div>
            </div>
            <div *ngIf="!loading && customSummaryTimeout &&
              selectedDaysPeriod=='3' && selectedRadioOptionInstalls==1">
              <div class="loader">
                <div>
                  <h5>Connection timed out !</h5>
                </div>
              </div>
            </div>
            <div *ngIf="!loading && summaryDataTimeout && (selectedDaysPeriod ==
              '0' || selectedDaysPeriod=='1' || selectedDaysPeriod=='2')">
              <div class="loader">
                <div>
                  <h5>Connection timed out !</h5>
                </div>
              </div>
            </div>
            <div *ngIf="!loading && !customSummaryTimeout &&
              selectedRadioOptionInstalls==1 && selectedDaysPeriod=='3'"
              class="hub-summary-info">
              <div class="title">
                <h5>Total HUB installations : {{hubsInstallCount}}</h5>
              </div>
            </div>
            <div *ngIf="!loading && !summaryDataTimeout &&
              selectedRadioOptionInstalls==1 && (selectedDaysPeriod=='1' ||
              selectedDaysPeriod=='2')" class="hub-summary-info">
              <h5>Total HUB installations : {{hubsInstallCount}}</h5>
            </div>
            <div *ngIf="!loading && !summaryDataTimeout &&
              selectedRadioOptionInstalls==1 && selectedDaysPeriod=='0' &&
              hubsInstallCount==0" class="hub-summary-info">
              <h5>Total HUB installations : {{hubsInstallCount}}</h5>
            </div>
            <div class="userdata-div" *ngIf="!loading && !summaryDataTimeout &&
              selectedRadioOptionInstalls==1 && selectedDaysPeriod=='0' &&
              hubsInstallCount!==0">
              <div class="title-accordion">
                <h5>Total HUB installations : {{hubsInstallCount}}</h5>
              </div>
              <nb-accordion class="table-accordion">
                <nb-accordion-item>
                  <nb-accordion-item-header>Show Customer Details</nb-accordion-item-header>
                  <nb-accordion-item-body>
                    <div fxLayout="row wrap" class="users-div">
                      <mat-card *ngFor="let user of hubUsersData" fxFlex="0 1
                        calc(33.3% - 32px)" fxFlex.lt-md="0 1 calc(50% - 32px)"
                        fxFlex.lt-sm="100%" class="searchResCard
                        mat-elevation-z8">
                        <mat-card-content [routerLink]="['/user', user._id]"
                          [state]="{ data: user}" style="cursor: pointer;">
                          <div class="user-profile">
                            <div class="name">{{user.userData[0].fullName}}</div>
                            <div class="email"
                              *ngIf="user.userData[0].emailId!=='NA'">{{user.userData[0].emailId}}</div>
                            <div class="mobile"
                              *ngIf="user.userData[0].mobile!=='NA'">{{user.userData[0].mobile}}</div>
                          </div>
                        </mat-card-content>
                      </mat-card>
                    </div>
                  </nb-accordion-item-body>
                </nb-accordion-item>
              </nb-accordion>
            </div>
            <div *ngIf="!loading && customSummaryTimeout &&
              selectedDaysPeriod=='3' && selectedRadioOptionInstalls==2">
              <div class="loader">
                <div>
                  <h5>Connection timed out !</h5>
                </div>
              </div>
            </div>
            <div *ngIf="!loading && !customSummaryTimeout &&
              selectedRadioOptionInstalls==2 && selectedDaysPeriod=='3'"
              class="node-count-table">
              <div class="total-count">
                <h5>Total node installations : {{totalNodesInstalled}}</h5>
              </div>
              <nb-accordion class="table-accordion">
                <nb-accordion-item>
                  <nb-accordion-item-header>Details</nb-accordion-item-header>
                  <nb-accordion-item-body>
                    <table mat-table [dataSource]="nodeTypeInstallCount"
                      class="mat-elevation-z8">
                      <ng-container matColumnDef="sr">
                        <th mat-header-cell *matHeaderCellDef> Sr.No. </th>
                        <td mat-cell *matCellDef="let element; let i= index;">
                          {{i+1}} </td>
                      </ng-container>
                      <ng-container matColumnDef="type">
                        <th mat-header-cell *matHeaderCellDef> Type/Model </th>
                        <td mat-cell *matCellDef="let element">
                          <span
                            nbPopoverTrigger="hover"
                            nbPopoverPlacement="left"
                            nbPopover='{{element.name?element.name+"
                            ("+element.type+")":element.type}}'>
                            {{element._id}}
                          </span></td>
                      </ng-container>
                      <ng-container matColumnDef="count">
                        <th mat-header-cell *matHeaderCellDef> Count </th>
                        <td mat-cell *matCellDef="let element">
                          {{element.count}} </td>
                      </ng-container>
                      <tr mat-header-row
                        *matHeaderRowDef="displayedColumnsForNode"></tr>
                      <tr mat-row *matRowDef="let row; columns:
                        displayedColumnsForNode;"></tr>
                    </table>
                  </nb-accordion-item-body>
                </nb-accordion-item>
              </nb-accordion>
            </div>
            <div *ngIf="!loading && !summaryDataTimeout &&
              selectedRadioOptionInstalls==2 && selectedDaysPeriod!=='3'"
              class="node-count-table">
              <div class="total-count">
                <h5>Total node installations : {{totalNodesInstalled}}</h5>
              </div>
              <nb-accordion class="table-accordion">
                <nb-accordion-item>
                  <nb-accordion-item-header>Details</nb-accordion-item-header>
                  <nb-accordion-item-body>
                    <table mat-table [dataSource]="nodeTypeInstallCount"
                      class="mat-elevation-z8">
                      <ng-container matColumnDef="sr">
                        <th mat-header-cell *matHeaderCellDef> Sr.No. </th>
                        <td mat-cell *matCellDef="let element; let i= index;">
                          {{i+1}} </td>
                      </ng-container>
                      <ng-container matColumnDef="type">
                        <th mat-header-cell *matHeaderCellDef> Type/Model </th>
                        <td mat-cell *matCellDef="let element">
                          <span
                            nbPopoverTrigger="hover"
                            nbPopoverPlacement="left"
                            nbPopover='{{element.name?element.name+"
                            ("+element.type+")":element.type}}'>
                            {{element._id}}
                          </span></td>
                      </ng-container>
                      <ng-container matColumnDef="count">
                        <th mat-header-cell *matHeaderCellDef> Count </th>
                        <td mat-cell *matCellDef="let element">
                          {{element.count}} </td>
                      </ng-container>
                      <tr mat-header-row
                        *matHeaderRowDef="displayedColumnsForNode"></tr>
                      <tr mat-row *matRowDef="let row; columns:
                        displayedColumnsForNode;"></tr>
                    </table>
                  </nb-accordion-item-body>
                </nb-accordion-item>
              </nb-accordion>
            </div>
          </div>
        </mat-tab>
        <mat-tab label="Online">
          <div class="summary-card-body">
            <div class="radio-div">
              <nb-radio-group name="radio-grp-online"
                [(value)]="selectedRadioOptionOnline" class="radio-btn-group">
                <nb-radio [value]="1">HUBS</nb-radio>
                <nb-radio [value]="2">Nodes</nb-radio>
              </nb-radio-group>
            </div>
            <div class="select-menu">
              <div class="select-options">
                <div><b style="font-size: 15px;">Select period of days </b>
                  <nb-select size="small" [(selected)]="selectedDaysPeriod"
                    (selectedChange)="setDaysPeriod()">
                    <nb-select-label>
                      <!-- If custom date range is selected, then show the date range as label else the current selected predefined day range-->
                      {{dateRange['startDate']!==""?dateRange['startDate']+'-'+dateRange['endDate']:
                      engagementDays[selectedDaysPeriod] }}
                    </nb-select-label>
                    <nb-option value="0">Last 7 days</nb-option>
                    <nb-option value="1">Last 15 days</nb-option>
                    <nb-option value="2">Last 30 days</nb-option>
                    <nb-option value="3">Custom Date Range</nb-option>
                  </nb-select>
                </div>
              </div>
            </div>
            <div class="loader" *ngIf="loading">
              <div>
                <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
              </div>
            </div>
            <div *ngIf="!loading && customSummaryTimeout && selectedDaysPeriod
              == '3'">
              <div class="loader">
                <div>
                  <h5>Connection timed out !</h5>
                </div>
              </div>
            </div>
            <div *ngIf="!loading && summaryDataTimeout && (selectedDaysPeriod ==
              '0' || selectedDaysPeriod=='1' || selectedDaysPeriod=='2')">
              <div class="loader">
                <div>
                  <h5>Connection timed out !</h5>
                </div>
              </div>
            </div>
            <div *ngIf="!loading && !summaryDataTimeout &&
              selectedRadioOptionOnline==1 && (selectedDaysPeriod=='0' ||
              selectedDaysPeriod=='1' || selectedDaysPeriod=='2')"
              class="hub-summary-info">
              <h5>Total Online HUBS : {{hubsOnlineCount}}</h5>
            </div>
            <div *ngIf="!loading && !customSummaryTimeout &&
              selectedRadioOptionOnline==1 && selectedDaysPeriod=='3'"
              class="hub-summary-info">
              <h5>Total Online HUBS : {{hubsOnlineCount}}</h5>
            </div>
            <div *ngIf="!loading && !customSummaryTimeout &&
              selectedRadioOptionOnline==2 && selectedDaysPeriod=='3'"
              class="node-count-table">
              <div class="total-count">
                <h5>Total online nodes : {{totalNodesOnline}}</h5>
              </div>
              <nb-accordion class="table-accordion">
                <nb-accordion-item>
                  <nb-accordion-item-header>Details</nb-accordion-item-header>
                  <nb-accordion-item-body>
                    <table mat-table [dataSource]="nodeTypeOnlineCount"
                      class="mat-elevation-z8">
                      <ng-container matColumnDef="sr">
                        <th mat-header-cell *matHeaderCellDef> Sr.No. </th>
                        <td mat-cell *matCellDef="let element; let i= index;">
                          {{i+1}} </td>
                      </ng-container>
                      <ng-container matColumnDef="type">
                        <th mat-header-cell *matHeaderCellDef> Type/Model </th>
                        <td mat-cell *matCellDef="let element">
                          <span
                            nbPopoverTrigger="hover"
                            nbPopoverPlacement="left"
                            nbPopover='{{element.name?element.name+"
                            ("+element.type+")":element.type}}'>
                            {{element._id}}
                          </span></td>
                      </ng-container>
                      <ng-container matColumnDef="count">
                        <th mat-header-cell *matHeaderCellDef> Count </th>
                        <td mat-cell *matCellDef="let element">
                          {{element.count}} </td>
                      </ng-container>
                      <tr mat-header-row
                        *matHeaderRowDef="displayedColumnsForNode"></tr>
                      <tr mat-row *matRowDef="let row; columns:
                        displayedColumnsForNode;"></tr>
                    </table>
                  </nb-accordion-item-body>
                </nb-accordion-item>
              </nb-accordion>
            </div>
            <div *ngIf="!loading && !summaryDataTimeout &&
              selectedRadioOptionOnline==2 && selectedDaysPeriod!=='3'"
              class="node-count-table">
              <div class="total-count">
                <h5>Total online nodes : {{totalNodesOnline}}</h5>
              </div>
              <nb-accordion class="table-accordion">
                <nb-accordion-item>
                  <nb-accordion-item-header>Details</nb-accordion-item-header>
                  <nb-accordion-item-body>
                    <table mat-table [dataSource]="nodeTypeOnlineCount"
                      class="mat-elevation-z8">
                      <ng-container matColumnDef="sr">
                        <th mat-header-cell *matHeaderCellDef> Sr.No. </th>
                        <td mat-cell *matCellDef="let element; let i= index;">
                          {{i+1}} </td>
                      </ng-container>
                      <ng-container matColumnDef="type">
                        <th mat-header-cell *matHeaderCellDef> Type/Model </th>
                        <td mat-cell *matCellDef="let element">
                          <span
                            nbPopoverTrigger="hover"
                            nbPopoverPlacement="left"
                            nbPopover='{{element.name?element.name+"
                            ("+element.type+")":element.type}}'>
                            {{element._id}}
                          </span></td>
                      </ng-container>
                      <ng-container matColumnDef="count">
                        <th mat-header-cell *matHeaderCellDef> Count </th>
                        <td mat-cell *matCellDef="let element">
                          {{element.count}} </td>
                      </ng-container>
                      <tr mat-header-row
                        *matHeaderRowDef="displayedColumnsForNode"></tr>
                      <tr mat-row *matRowDef="let row; columns:
                        displayedColumnsForNode;"></tr>
                    </table>
                  </nb-accordion-item-body>
                </nb-accordion-item>
              </nb-accordion>
            </div>
          </div>
        </mat-tab>
      </mat-tab-group>
    </nb-card-body>
    <div class="bottom-div">
      <div *ngIf="!loading && !summaryDataTimeout &&
        selectedRadioOptionInstalls==1 && selectedDaysPeriod=='0' && tabIndex==0
        && hubsInstallCount!==0" class="export-btn">
        <button style="cursor: pointer;" nbButton status="primary" size="small"
          (click)="downloadExcelFile()">Export</button>
      </div>
      <div class="update-time" *ngIf="!loading">
        <b>Last updated : {{dataUpdatedTime | date: 'medium'}}</b><br>
      </div>
    </div>
  </div>

  <!-- graph section -->
  <div class="hub-installation-graph" *ngIf="!loading && tabIndex==0 &&
    selectedRadioOptionInstalls==1">
    <nb-toggle labelPosition="start" [(checked)]="checkedGraphOption"
      (click)="graphOptionToggled()">
      Show 1 Year HUB Installations Graph
    </nb-toggle><br>
    <div class="loader" *ngIf="loadingGraphData && installationGraphChecked">
      <mat-spinner></mat-spinner>
    </div>
    <div class="loader" *ngIf="graphDataTimeout && installationGraphChecked">
      <div>
        <h6>No graph data found !</h6>
      </div>
    </div>
    <div *ngIf="!loadingGraphData && !graphDataTimeout &&
      installationGraphChecked">
      <plotly-plot [config]="graphConfig" [data]="graphDataForLastYear"
        [layout]="graphDataForLastYearLayout"></plotly-plot><br><br>
      <h6 style="text-align: center;">Total HUB Installations :
        {{oneYearHubCount}}</h6><br>
    </div>
  </div>
  <!-- graph section -->

</nb-card>
<!-- eGlu summary card -->

<!-- hub firmware card -->
<div fxLayout="row wrap" fxLayout.lt-sm="column" fxLayoutGap="12px"
  fxLayoutAlign="flex-start">
  <nb-card style="border-radius: 18px;" fxFlex="0 1 calc(33.3% - 12px)"
    fxFlex.lt-md="0 1 calc(33.3% - 32px)" fxFlex.lt-sm="100%">
    <nb-card-header>
      <div fxLayout="row" fxLayoutAlign="space-between">
        <div fxLayout="column">
          <h6>HUB Database Analytics</h6>
          <small class="database-analytics-updated-at">
            Last updated: {{databaseInfo.lastUpdatedAt ? (databaseInfo.lastUpdatedAt | date:'medium') : 'Not updated yet'}}
          </small>
        </div>
        <button nbButton ghost status="primary"
                                (click)="getHubDataBaseInfo()" [disabled]="isLoadingDatabaseAnalytics">
                                <nb-icon icon="sync-outline"></nb-icon>
        </button>
      </div>
    </nb-card-header>
    <nb-card-body>
      <div *ngIf="!isLoadingDatabaseAnalytics" fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="12px">
        <span>Total Customer HUBs</span>
        <b>{{databaseInfo.totalCustomerHubs}}</b>
        <span>Total Provision Commissioned HUBs</span>
        <b>{{databaseInfo.totalProvisionCommissionedHubs}}</b>
        <span>Total App Current Status HUBs</span>
        <b>{{databaseInfo.totalAppCurrentStatusHubs}} (Online: {{databaseInfo.totalAppCurrentStatusHubsOnline}} / Offline: {{databaseInfo.totalAppCurrentStatusHubsOffline}})</b>
        <span>Total Redis Online HUBs</span>
        <b>{{databaseInfo.totalRedisOnlineHubs}}</b>
        <span>Total Personalization HUBs</span>
        <b>{{databaseInfo.totalPersonalizationHubs}}</b>
      </div>
      <div *ngIf="isLoadingDatabaseAnalytics" fxLayout="column" fxLayoutAlign="center center" style="height: 100%;">
          <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
      </div>
    </nb-card-body>
  </nb-card>
  <nb-card style="border-radius: 18px;" fxFlex="0 1 calc(33.3% - 12px)"
    fxFlex.lt-md="0 1 calc(33.3% - 32px)" fxFlex.lt-sm="100%">
    <nb-card-header>
      <h6>HUB Firmware Analytics</h6>
    </nb-card-header>
    <nb-card-body style="margin: 0 auto;">
      <div class="analytics-input-form">
        <div>
          <input nbInput placeholder="Enter HUB Firmware version" required
            [(ngModel)]="hubFirmwareVersion">
        </div>
        <div style="display: flex; flex-wrap: wrap; align-items: center; gap:
          8px; width: 100%;">
          <div>
            <b>HUB Type :</b>
          </div>
          <div>
            <nb-radio-group name="radio-grp-hubType" [(value)]="hubType"
              class="firmware-radio-group">
              <nb-radio [value]="1">HUB</nb-radio>
              <nb-radio [value]="2">HUB Lite</nb-radio>
              <nb-radio [value]="3">HUB Pro</nb-radio>
              <nb-radio [value]="4">HUB Plus</nb-radio>
            </nb-radio-group>
          </div>
        </div>
        <div style="display: flex; flex-wrap: wrap; align-items: center; gap:
          8px; width: 100%;">
          <div>
            <b>Equality :</b>
          </div>
          <div>
            <nb-radio-group name="radio-grp-equality" [(value)]="equality"
              class="firmware-radio-group">
              <nb-radio [value]="1">Greater than</nb-radio>
              <nb-radio [value]="2">Less than</nb-radio>
            </nb-radio-group>
          </div>
        </div>
        <div>
          <button style="cursor: pointer; width: 100%;" nbButton
            status="primary" size="medium"
            (click)="firmwareInfo(hubFirmwareVersion, hubType, equality)">Continue</button>
        </div>
      </div>
      <div class="analytics-table">
        <div class="loader" *ngIf="loadingAnalytics">
          <div>
            <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
          </div>
        </div>
        <div style="margin-top: 3%;" *ngIf="!loadingAnalytics &&
          dataSourceForFirmwareCounts.length">
          <h6>Results</h6>
          <table mat-table [dataSource]="dataSourceForFirmwareCounts"
            class="mat-elevation-z8">
            <ng-container matColumnDef="valueName">
              <th mat-header-cell *matHeaderCellDef></th>
              <td mat-cell *matCellDef="let element"> {{element.valueName}}
              </td>
            </ng-container>
            <ng-container matColumnDef="valueCount">
              <th mat-header-cell *matHeaderCellDef> Count </th>
              <td mat-cell *matCellDef="let element"> {{element.valueCount}}
                ({{element.valuePercentage}}%)</td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="columnsForFirmwareAnalytics"></tr>
            <tr mat-row *matRowDef="let row; columns:
              columnsForFirmwareAnalytics;"></tr>
          </table>
        </div>
      </div>
      <div style="margin-top: 3%;" class="analytics-table">
        <div *ngIf="!loadingAnalytics &&
          dataSourceForTotalFirmwareCounts.length">
          <h6>Total results</h6>
          <table mat-table [dataSource]="dataSourceForTotalFirmwareCounts"
            class="mat-elevation-z8">
            <ng-container matColumnDef="valueName">
              <th mat-header-cell *matHeaderCellDef></th>
              <td mat-cell *matCellDef="let element"> {{element.valueName}}
              </td>
            </ng-container>
            <ng-container matColumnDef="valueCount">
              <th mat-header-cell *matHeaderCellDef> Count </th>
              <td mat-cell *matCellDef="let element"> {{element.valueCount}}
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="columnsForFirmwareAnalytics"></tr>
            <tr mat-row *matRowDef="let row; columns:
              columnsForFirmwareAnalytics;"></tr>
          </table>
        </div>
      </div>
    </nb-card-body>
  </nb-card>
  <nb-card style="border-radius: 18px;" fxFlex="0 1 calc(33.3% - 12px)"
    fxFlex.lt-md="0 1 calc(33.3% - 32px)" fxFlex.lt-sm="100%">
    <nb-card-header>
      <h6>Old HUB Firmware Analytics</h6>
    </nb-card-header>
    <nb-card-body>
      <div class="analytics-table">
        <div class="loader" *ngIf="loadingAnalytics">
          <div>
            <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
          </div>
        </div>
      </div>
      <div style="margin-top: 3%;" class="analytics-table">
        <div *ngIf="!loadingAnalytics &&
          dataSourceForOldHubTotalFirmwareCounts.length">
          <table mat-table
            [dataSource]="dataSourceForOldHubTotalFirmwareCounts">
            <ng-container matColumnDef="valueName">
              <th mat-header-cell *matHeaderCellDef></th>
              <td mat-cell *matCellDef="let element"> {{element.valueName}}
              </td>
            </ng-container>
            <ng-container matColumnDef="valueCount">
              <th mat-header-cell *matHeaderCellDef> Count </th>
              <td mat-cell *matCellDef="let element"> {{element.valueCount}}
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="columnsForFirmwareAnalytics"></tr>
            <tr mat-row *matRowDef="let row; columns:
              columnsForFirmwareAnalytics;"></tr>
          </table>
        </div>
      </div>
    </nb-card-body>
  </nb-card>
</div>
<!-- hub firmware card -->

<div>
  <nb-card class="dashInfoCard" fxFlex="0 1 calc(100% - 32px)"
    fxFlex.lt-md="0 1 calc(100% - 32px)" fxFlex.lt-sm="100%">
    <nb-card-header>State-Wise Online HUBs (India)</nb-card-header>
    <nb-card-body>
      <div id="regions_div">
        
      </div>
    </nb-card-body>
  </nb-card>
</div>

<div fxLayout="row wrap" fxLayout.lt-sm="column" fxLayoutGap="32px"
  fxLayoutAlign="flex-start">
  <nb-card class="dashInfoCard" fxFlex="0 1 calc(33.3% - 32px)"
    fxFlex.lt-md="0 1 calc(33.3% - 32px)" fxFlex.lt-sm="100%">
    <nb-card-header>Hubs</nb-card-header>
    <nb-card-body>
      <mat-spinner *ngIf="hubsGraph.data.length == 0 "></mat-spinner>
      <!-- <plotly-plot [config] = "grapgConfig" [style]="{position: 'relative', width: '100%', height: '100%'}"  *ngIf="hubsGraph.data.length"  [data]="hubsGraph.data" [layout]="hubsGraph.layout"></plotly-plot> -->
      <google-chart style="width: 400px; height: 300px;" [type]="hubsGraph.type"
        [data]="hubsGraph.data"></google-chart>
    </nb-card-body>
  </nb-card>
  <nb-card class="dashInfoCard" fxFlex="0 1 calc(33.3% - 32px)"
    fxFlex.lt-md="0 1 calc(33.3% - 32px)" fxFlex.lt-sm="100%">
    <nb-card-header>Users</nb-card-header>
    <nb-card-body>
      <mat-spinner *ngIf="usersGraph.data.length == 0 "></mat-spinner>
      <!-- <plotly-plot [config] = "grapgConfig" [style]="{position: 'relative', width: '100%', height: '100%'}" *ngIf="usersGraph.data.length" [data]="usersGraph.data" [layout]="usersGraph.layout"></plotly-plot> -->
      <google-chart style="width: 400px; height: 300px;"
        [type]="usersGraph.type" [data]="usersGraph.data"></google-chart>
    </nb-card-body>
  </nb-card>
  <nb-card class="dashInfoCard" fxFlex="0 1 calc(33.3% - 32px)"
    fxFlex.lt-md="0 1 calc(33.3% - 32px)" fxFlex.lt-sm="100%">
    <nb-card-header>Assistants Linked</nb-card-header>
    <nb-card-body>
      <mat-spinner *ngIf="assistantsGraph.data.length == 0 "></mat-spinner>
      <!-- <plotly-plot [config] = "grapgConfig" [style]="{position: 'relative', width: '100%', height: '100%'}"  *ngIf="assistantsGraph.data.length" [data]="assistantsGraph.data" [layout]="assistantsGraph.layout"></plotly-plot> -->
      <google-chart style="width: 400px; height: 300px;"
        [type]="assistantsGraph.type" [data]="assistantsGraph.data"></google-chart>
    </nb-card-body>
  </nb-card>
</div>



<!--
  fetatures to implement on dashboard:
    online/offline hubs,
    assistants linked,
    no of user with/without hubs,


  fetatures to implement on userDetail:
    show owner of hub and access list

 -->
